import { NavigationGuardNext, RouteLocationNormalized } from 'vue-router'

import { pathNames } from '@/shared/utils/constants'

import { setAlarmItemSettingsPropsResolver } from './lazy-route-props'

export const alarmItemSettingsBeforeEnter = async (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext,
): Promise<void> => {
  const [{ useStoreAlarm }, { alarmItemSettingsPropsFn }] = await Promise.all([
    import('@/entities/alarm'),
    import('./alarmItemSettingsPropsFn'),
  ])
  setAlarmItemSettingsPropsResolver(alarmItemSettingsPropsFn)

  const { fetchAlarmSchedules, fetchPromptAlarmSubscriber } = useStoreAlarm()

  try {
    if (from.name !== 'alarm' && from.name !== pathNames.SUPPORT_ALARM_SCHEDULE_MAIN) {
      await Promise.all([fetchAlarmSchedules(), fetchPromptAlarmSubscriber()])
    }
    if (!to.meta) {
      to.meta = {}
    }
    to.meta.alarmItemSettingsProps = alarmItemSettingsPropsFn(to)
    next()
  } catch (e) {
    console.error(e)
  }
}
